import { render, staticRenderFns } from "./TVODHeroSection.vue?vue&type=template&id=a33322ae&scoped=true"
import script from "./TVODHeroSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TVODHeroSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TVODHeroSection.vue?vue&type=style&index=0&id=a33322ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33322ae",
  null
  
)

export default component.exports